
import ContactDetails from './ContactDetails';
import LoginDetails from './LoginDetails';
import Photo from './Photo';
import Preferences from './Prefrences';
import Address from './Address';
import PersonalDetails from './PersonalDetails';
import { useState } from 'react';
import { useRef } from "react";
import { toast } from 'react-toastify';
import PageHeading from 'Layout/AppMain/PageHeading';
import Loader from 'react-loaders';
import { useProfile, useSaveProfile } from 'Api/Profile';
import moment from 'moment';

const Profile = () => {

  const [errorField, setErrorField] = useState({});
  const saveTimeout = useRef(null);
  const { trigger: saveProfile } = useSaveProfile();

  const {
    data: profileResponse,
    mutate,
    isLoading,
  } = useProfile();

  const data = profileResponse?.data ?? {};
  const profileData = profileResponse?.data?.profileList ?? {};



  const handleFieldChange = (field, value) => {
    if (saveTimeout.current) {
      clearTimeout(saveTimeout.current);
    }
    if (field === "vUserName" && value === profileData?.vUserName) {
      toast.error("Gebruikersnaam is niet gewijzigd.");
      setErrorField(field);
      return;
    }
    saveTimeout.current = setTimeout(() => {
      const payload = {
        iAdminId: profileData?.iAdminId,
        attr: field,
        [field]: value
      };

      saveProfile({
        data: payload
      })
        .then((res) => {
          mutate();
          console.log("Updated successfully", res.data);
        })
        .catch((err) => {
          console.error("Update error", err);
        });

    }, 1000);
  };

  const handleSaveField = async (values) => {
    try {
      const payload = {
        iAdminId: profileData?.iAdminId,
        attr: {
          ...values,
          dBirthdate: values.dBirthdate
            ? moment(values.dBirthdate).format("DD-MM-YYYY")
            : "",
        },
      };

      const response = await saveProfile({
        data: payload,
      });

      if (response?.status || response?.success) {
        setErrorField({});
        await mutate();
        return;
      }

      const errorData = response?.data || {};

      setErrorField(errorData);

      Object.values(errorData).forEach((errors) => {
        if (Array.isArray(errors)) {
          toast.error(errors.join(", "));
        } else if (errors) {
          toast.error(errors);
        }
      });
    } catch (err) {
      console.error("Update error", err);
    }
  };


  return (
    <>
      {
        isLoading ?
          <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
          :
          <>
            <PageHeading />
            <div className="row profiel border-2">
              <div className="col-xxl-12 col-lg-8 ">
                <div className='gap-4 d-flex flex-column'>

                  <div className="row">
                    <div className="col-xxl-4 col-12  ">
                      <PersonalDetails data={profileData} handleFieldChange={handleFieldChange} handleSave={handleSaveField} errorField={errorField} />
                    </div>
                    <div className="col-xxl-4 col-12 ">

                      <ContactDetails data={profileData} handleFieldChange={handleFieldChange} handleSave={handleSaveField} errorField={errorField} />
                    </div>


                    <div className="col-xxl-4 col-12 ">
                      <Photo data={profileData} />
                    </div>
                  </div>
                  <div className="row">

                    <div className="col-xxl-4 col-12 ">
                      <Address data={profileData} handleFieldChange={handleFieldChange} />
                    </div>


                    <div className="col-xxl-4 col-12 ">
                      <LoginDetails data={data} handleFieldChange={handleFieldChange} errorField={errorField} fetchProfileData={mutate} />
                    </div>


                    <div className="col-xxl-4 col-12 ">
                      <Preferences data={data} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
      }
    </>
  );
};

export default Profile;